var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19607"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19598",
  transform: "translate(-658 -29)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "none",
  "data-name": "Ellipse 1393",
  transform: "translate(658 29)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15094"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M663.737 34.592h19.527v19.527h-19.527z",
  "data-name": "Rectangle 6435"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M682.046 39.086a7 7 0 0 1-1.727.492c.277-.046.686-.55.849-.753a3.2 3.2 0 0 0 .573-1.046c.015-.029.026-.067 0-.09a.1.1 0 0 0-.092.008 8.8 8.8 0 0 1-2.048.784.14.14 0 0 1-.141-.038 2 2 0 0 0-.179-.183 3.7 3.7 0 0 0-.992-.608 3.45 3.45 0 0 0-1.522-.245 3.6 3.6 0 0 0-1.443.408 3.7 3.7 0 0 0-1.165.951 3.6 3.6 0 0 0-.7 1.393 3.8 3.8 0 0 0-.037 1.471c.011.082 0 .093-.071.082a10.94 10.94 0 0 1-7.038-3.583c-.082-.093-.127-.093-.193.007a3.57 3.57 0 0 0 .608 4.217c.138.13.28.261.433.38a3.6 3.6 0 0 1-1.358-.38c-.082-.052-.123-.023-.13.071a2 2 0 0 0 .022.4 3.61 3.61 0 0 0 2.225 2.877 2 2 0 0 0 .451.138 4 4 0 0 1-1.332.041c-.1-.018-.134.03-.1.123a3.75 3.75 0 0 0 2.8 2.344c.127.022.254.022.381.052-.007.011-.015.011-.023.022a4.43 4.43 0 0 1-1.911 1.013 6.85 6.85 0 0 1-2.9.371c-.156-.023-.188-.021-.231 0s-.005.064.045.1c.2.131.4.247.6.359a9.6 9.6 0 0 0 1.94.776 10.33 10.33 0 0 0 10.033-2.346 10.53 10.53 0 0 0 2.777-7.68c0-.11.13-.171.207-.23a6.8 6.8 0 0 0 1.365-1.42.43.43 0 0 0 .09-.272v-.015c.004-.036.003-.022-.066.009",
  "data-name": "Path 6011"
}))))));
export { SvgTwitter as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.8784fa0d535d0ff01775664b58e739a7.svg";